import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Role, User } from 'src/app/_models';
import { UserInfo } from 'src/app/_models/user-info';
import { MessService } from 'src/app/_services/mess-service.service';
import { UsersService } from 'src/app/_services/users.service';

@Component({
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html',
})
export class UsersEditComponent implements OnInit, OnDestroy {
  updateUserForm: FormGroup;
  userForUpdate: UserInfo;
  roles: any[];
  subscriptions: Subscription[] = [];
  editedPassword = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private messService: MessService,
    private fb: FormBuilder
  ) {
    this.roles = Object.entries(Role)
      .filter((e) => !isNaN(e[0] as any))
      .map((e) => ({ name: e[1], role_id: +e[0] }));
  }

  // * Lifecycles === //
  ngOnInit(): void {
    this.updateUserForm = this.fb.group({
      fname: [''],
      lname: [''],
      username: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      // password: [''],
      // password_confirmation: [''],
      role_id: [this.roles[0].role_id, [Validators.required]],
    });

    this.subscriptions.push(
      this.usersService.updateUserData.subscribe((responseData: UserInfo) => {
        if (!responseData) {
          this.router.navigate(['./../'], { relativeTo: this.route });
          return;
        }
        this.userForUpdate = responseData;
        this.patchFormForUpdate();
      })
    );

    // * On Change User Role
    this.subscriptions.push(
      this.updateUserForm.get('role_id').valueChanges.subscribe({
        next: (value) => {
          if (value && value === Role.radnik) {
            this.updateUserForm.get('email').clearValidators();
            this.updateUserForm.get('email').updateValueAndValidity();
          } else {
            this.updateUserForm
              .get('email')
              .setValidators([Validators.required, Validators.email]);
            this.updateUserForm.get('email').updateValueAndValidity();
          }
        },
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onUpdateUser() {
    const user = this.updateUserForm.getRawValue();
    this.usersService.updateUser(this.userForUpdate.id, user).subscribe(
      () => {
        this.messService.add({
          severity: 'success',
          title: 'Uspešno ažuriranje',
          detail: 'Ažurirali ste korisnika.',
        });
        this.router.navigate(['./../'], { relativeTo: this.route });
      },
      (error) => {
        const errorObj = error.error.errors;
        const form = this.updateUserForm;
        const messService = this.messService;

        Object.keys(errorObj).forEach(function (key) {
          const formControl = form.get(key);
          if (formControl) {
            // If error exist set red border to field
            formControl.setErrors({});
          }
          // Push toast error for every field
          messService.addError({
            severity: 'error',
            title: 'Greška',
            detail: errorObj[key],
            sticky: true,
          });
        });
      }
    );
  }

  // * Helpers === //
  patchFormForUpdate() {
    this.updateUserForm.patchValue({
      fname: this.userForUpdate.fname,
      lname: this.userForUpdate.lname,
      username: this.userForUpdate.username,
      email: this.userForUpdate.email,
      role_id: this.userForUpdate.role_id,
    });

    // * Check for Role and Set Email Validation
    if (this.userForUpdate.role_id === Role.radnik) {
      this.updateUserForm.get('email').clearValidators();
    }
  }

  onEditPassword() {
    this.updateUserForm.addControl(
      'password',
      this.fb.control('', Validators.required)
    );
    this.updateUserForm.addControl(
      'password_confirmation',
      this.fb.control('', Validators.required)
    );
    this.editedPassword = true;
  }
}
